import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';

import { EditorComponent } from './tag-editor.component';
import { PrettyTagsPipe } from './tag-editor.pipe';

import { SelectMenuModule } from './select-menu/select-menu.module';
import { TagsFormatService } from '../tags/tags-format.service';

@NgModule({
	declarations: [EditorComponent, PrettyTagsPipe],
	imports: [BrowserModule, BrowserAnimationsModule, SelectMenuModule, FormsModule, TranslateModule],
	exports: [EditorComponent],
	providers: [TagsFormatService],
	bootstrap: []
})
export class TagEditorModule {}



// WEBPACK FOOTER //
// ./src/app/modules/tag-editor/tag-editor.module.ts